(function ($) {
  $(function () {
    var announcement = $('.js-global-announcement');

    if (!announcement.length) {
      return;
    }

    var key = announcement.data('announcement-key');
    var cookieName = announcement.data('announcement-cookie');

    var closeButton = announcement.find('.js-global-announcement-close');

    function rememberClosed() {
      var secure = window.location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = cookieName + '=' + encodeURIComponent(key) + '; path=/; max-age=31536000; SameSite=Lax' + secure;
    }

    closeButton.on('click', function () {
      rememberClosed();
      announcement.remove();
    });
  });
}(jQuery));
